module.exports = __webpack_public_path__ + "static/media/Finance@10x.7fe24d65.png";